/* eslint-disable prettier/prettier */
import React from 'react'
import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'
import { showToast } from './toastSlice'
import makeRequest from 'src/services/api'
import handleGeneralError from '../helpers/errorHandler'
import { fetchMemberListNotificationUrl, editMemberListUrl, } from 'src/services/urls'
import { getUniqueListBy } from 'src/lib/utils'

const initialState = {
  loading: false,
  data: { hasMore: false, page: 1, totalDocs: 0, nextPage: 0 },
  docs: [],
  error: '',
  activePage: 0,
  dateRange: { startDate: '', endDate: '' },
}

// Fetch loyalty members list
export const fetchMemberListNotification = createAsyncThunk('memberListNotification/fetchMemberListNotification', async (options, { dispatch, getState }) => {
  try {
    const skip = options?.skip
    const limit = options?.limit
    const startTimestamp = options?.startTimestamp
    const endTimestamp = options?.endTimestamp
    const filter = options?.filter
    const response = await makeRequest(fetchMemberListNotificationUrl(skip, limit, startTimestamp, endTimestamp))
    return { docs: response.data.data.docs, data: response.data.data, filtered: filter }

  } catch (e) {
    handleGeneralError(e, { dispatch, showToast })
    return { error: e?.response?.data?.error?.message }

  }
})

// Edit/Update or enable/disable a loyalty member
export const editMemberListNotification = createAsyncThunk('memberListNotification/editMemberListNotification', async (data, { dispatch, getState }) => {
  try {
    let body = data
    const state = getState()
    const { dateRange } = state.memberListNotification
    const startDate = dateRange?.startDate
    const endDate = dateRange?.endDate

    const response = await makeRequest(editMemberListUrl(), 'PUT', body)

    const { displayMessage, status } = response.data

    if (response.data.statusCode === 200) {
      dispatch(showToast({ title: status, message: displayMessage, color: 'success' }))
    }
    dispatch(fetchMemberListNotification({ limit: 500, filter: true, startTimestamp: startDate ? startDate.getTime() : '', endTimestamp: endDate ? endDate.getTime() : '' }))
    return response.data

  } catch (e) {
    handleGeneralError(e, { dispatch, showToast })
  }
})

const memberListNotificationSlice = createSlice({
  name: 'memberListNotification',
  initialState,
  reducers: {
    setActivePage: (state, action) => {
      state.activePage = action.payload
    },
    setDateRangeSlice: (state, action) => {
      state.dateRange = action.payload
    }
  },
  extraReducers: (builder) => {
    builder.addCase(fetchMemberListNotification.pending, (state) => {
      state.loading = state.docs.length > 0 ? false : true
    })
    builder.addCase(fetchMemberListNotification.fulfilled, (state, action) => {
      state.loading = false
      state.error = action.payload.error

      if (action.payload.docs) {
        state.data = action.payload.data
        const oldData = action.payload.filtered ? [] : state.docs
        const totalData = [...oldData, ...action.payload.docs]
        const uniqueData = getUniqueListBy(totalData, 'membershipId')
        state.docs = uniqueData
      }
    })
    builder.addCase(fetchMemberListNotification.rejected, (state, action) => {
      state.loading = false
      state.data = {}
      state.docs = []
      state.error = action.error.message
    })
    builder.addCase(editMemberListNotification.fulfilled, (state, action) => {
      // state.activePage = 0
      state.loading = false
      state.error = ''
    })
    builder.addCase(editMemberListNotification.rejected, (state, action) => {
      state.loading = false
      state.error = action.error.message
    })

  },
})

export default memberListNotificationSlice.reducer
export const { setActivePage, setDateRangeSlice } = memberListNotificationSlice.actions
